import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import config from './auth/config';
import '@babel/polyfill';
import Routes from './components/Routes';
import configureStore from './store/configurestore';
import './util/svg';
import initialState from './reducers/initialstate';
import env from './util/env';
import utility from './util/utilityfunctions';
import {Providers, ProviderState, Graph, Msal2Provider} from '@microsoft/mgt';
import {checkUserAcceptedPaansPolicy} from './actions/Paans/paansaction';
import {getConfigurations} from './actions/Configuration/configurationactions';
import {serviceURL} from './util/uiconstants';
import {getUserPreferences} from './actions/UserPreferences/userpreferencesaction';
import {MsalService} from '@ey/voltron-core';
import {Client} from '@microsoft/microsoft-graph-client';
import {initMyEyUserContext} from '@ey/voltron-myeyintegration';

document.addEventListener('DOMContentLoaded', () => {
	const store = configureStore(initialState);
	console.log('🌵 <<< DOM loaded >>> 🌵');
	initMyEyUserContext(store);
	store.dispatch({type: 'HOME_LOGIN'}).then(() => {
		const authService = new MsalService(config);
		const account = authService.getActiveAccount();
		if (account) {
			const scopes = [
				'user.read',
				'user.read.all',
				'Presence.Read',
				'Presence.Read.All',
				'people.read',
				'contacts.read'
			];

			const provider = new Msal2Provider({
				clientId: config.auth.clientId,
				authority: config.auth.authority,
				scopes: scopes,
				cache: {
					cacheLocation: config.cache.cacheLocation
				},
				loginHint: account.username
			});

			const options = {
				authProvider: provider,
				fetchOptions: {headers: {'X-PeopleQuery-QuerySources': 'Mailbox,Directory'}}
			};

			const client = Client.initWithMiddleware(options);
			provider.graph = new Graph(client);

			Providers.globalProvider = provider;
			Providers.globalProvider.setState(ProviderState.SignedIn);
		}

		let requestURL = env.getBaseURL(serviceURL) + 'Users/Me';
		let configUrl = env.getBaseURL(serviceURL) + 'Configuration';
		store.dispatch(getConfigurations(configUrl));
		// Call PAANs service to check if user has accepted the policy and redirect if not accepted
		let paansUrl = env.getBaseURL(serviceURL) + 'Paans';
		console.log('Before checkUserAcceptedPaansPolicy()');
		store
			.dispatch(checkUserAcceptedPaansPolicy(paansUrl))
			.then(() => {
				console.log('After checkUserAcceptedPaansPolicy()');
				let userHasAcceptedPolicy = store.getState().paansuserdata;
				let hasaccepted = userHasAcceptedPolicy.hasAccepted;
				let redirectUrl = userHasAcceptedPolicy.redirectUrl;
				if (hasaccepted !== undefined && redirectUrl !== undefined) {
					if (hasaccepted === false) {
						window.location.href = redirectUrl;
					}
				}

				if (hasaccepted === true || !userHasAcceptedPolicy.isPaansEnabled) {
					store.dispatch(getUserPreferences(requestURL));
				}
			})
			.catch((paansError) => {
				let errorMessage = utility.getErrorMessageFromResponse(utility.getErrorMessage(paansError));
				console.log('Error in PAANS: ', errorMessage);
			});

		const container = document.getElementById('mount');
		const root = createRoot(container);

		root.render(
			/*Provider component attaches the store to React components*/
			<Provider store={store}>
				<BrowserRouter>
					<Routes />
				</BrowserRouter>
			</Provider>
		);
	});
});
